import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from "axios";
import { baseUrl } from './config';
import Cookies from 'js-cookie';

export const CountryList = createAsyncThunk(
    'auth/CountryList',
    async () => {
        let url = baseUrl+'countryList';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        }))
       
        if(response.data.status === "success"){
        
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
  );

  export const countryCode = createAsyncThunk(
    'auth/countryCode',
    async (data) => {
        let url = baseUrl+'countryCode';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },


  );

  export const CityList = createAsyncThunk(
    'auth/CityList',
    async () => {
        let url = baseUrl+'cityList';
        const token=Cookies.get("token");
      try {
        const response = (await axios.get(url,{
          headers: {
              Authorization: `Bearer ${token}`, 
          },
        })).data
        if(response.status === "success"){
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
      } catch (err) {

        return Promise.reject(err)
      }
    },
 
    
  );

 
